import { useEffect } from 'react';
import { queryClient, ApiError, safeSignInPath } from '../lib/api/client.js';
import {
  evictPrivateQueries,
  getSessionQueryKey,
  getSessionQueryOptions,
} from '../lib/api/queries.js';

export async function refreshAuthorization(): Promise<void> {
  await queryClient.cancelQueries({ queryKey: getSessionQueryKey() });
  await queryClient.query(
    getSessionQueryOptions({
      request: { headers: { 'x-solidops-activity': 'foreground' } },
    }),
  );
}

export function useAuthorizationRefresh(): void {
  useEffect(() => {
    const refresh = (): void => {
      if (document.visibilityState !== 'visible') return;
      if (
        window.location.pathname === '/account/contacts/verify' &&
        new URLSearchParams(window.location.search).get('status') === 'unavailable'
      )
        return;
      void refreshAuthorization().catch((error) => {
        if (error instanceof ApiError && error.status === 401) {
          evictPrivateQueries();
          window.location.assign(safeSignInPath());
        }
      });
    };
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);
}
